<div class="dashboard__bg">
  <div class="dashboard__bg_image">
    @if (this.dashboard.imageBody) {
      <img
        [src]="this.sanitizer.bypassSecurityTrustResourceUrl('data:' + this.dashboard.imageType + ';base64,' + this.dashboard.imageBody)" />
    }
  </div>
  <div class="dashboard__wrap">
    <h1 [style.color]="this.dashboard.headColor" class="color-white font-weight-normal">
      {{ this.isLanguageUa ? this.dashboard.headUa : this.dashboard.headRu }}
    </h1>
    <shared-search-service-full></shared-search-service-full>
  </div>
</div>
<div class="dashboard__wrap">
  <p class="dashboard__switch-slogan font-size-18" [style.color]="this.dashboard.bodyColor">
    {{ this.isLanguageUa ? this.dashboard.bodyUa : this.dashboard.bodyRu }}
  </p>
  <div class="dashboard__switch-btn text-center">
    <dx-button
      text="{{ 'SWITCH_TO_CATALOG' | translate }}"
      class="btn btn-fanning btn-big px-5 py-1 font-weight-normal"
      (onClick)="this.goToServiceCatalogPage()"></dx-button>
  </div>
  <p class="dashboard__services-slogan font-size-22 font-weight-middle">
    {{ 'MOST_POPULAR_QUERIES' | translate }}
  </p>
  <div>
    @for (topService of this.topServices; track topService) {
      <div class="text-start">
        <dx-button (onClick)="this.createOrder(topService.service)" class="dashboard__services-btn">
          <div class="dashboard__services-btn d-flex align-items-center">
            <div>
              @if (topService.service.category.iconBody) {
                <img
                  style="width: 40px"
                  [src]="
                    this.sanitizer.bypassSecurityTrustResourceUrl(
                      'data:' + topService.service.category.iconType + ';base64,' + topService.service.category.iconBody
                    )
                  " />
              }
              @if (!topService.service.category.iconBody) {
                <img style="width: 40px" src="../assets/images/nophoto.png" />
              }
            </div>
            <div class="services-btn text-start">
              <p class="services-btn__name font-size-16 color-black">
                {{ this.isLanguageUa ? topService.service.nameUa : topService.service.nameRu }}
              </p>
              <p class="services-btn__desc font-size-13 color-grey-desc m-0">
                {{ this.isLanguageUa ? topService.service.category.nameUa : topService.service.category.nameRu }}
              </p>
            </div>
          </div>
        </dx-button>
      </div>
    }
  </div>
</div>
